import { render, staticRenderFns } from "./mbrstatistique.vue?vue&type=template&id=2df0a22c&scoped=true&"
import script from "./mbrstatistique.vue?vue&type=script&lang=js&"
export * from "./mbrstatistique.vue?vue&type=script&lang=js&"
import style0 from "./mbrstatistique.vue?vue&type=style&index=0&id=2df0a22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0a22c",
  null
  
)

export default component.exports